export type NfeTipo = 0 | 1; // 0 = Entrada, 1 = Saida
export type NfeModelo = 55 | 65; // 55 = NF-e, 65 = NFC-e
export type NfeStatus = 'autorizada' | 'cancelada';

export interface DashboardSummary {
  totalNfe: number;
  totalNfce: number;
  totalAutorizadas: number;
  totalCanceladas: number;
  totalFaturado: number;
  totalImpostos: number;
  empresasComMovimento: number;
  ticketMedio: number;
}

export interface DashboardTimelineItemResponse {
  periodo: string;
  total: number;
  faturado: number;
  canceladas: number;
}

export interface DashboardTimelineHourlyItemResponse {
  hora: number;
  total: number;
  faturado: number;
}

export interface DashboardTimelineWeekdayItemResponse {
  diaSemana: number;
  total: number;
  faturado: number;
}

export interface DashboardTaxBreakdown {
  icms: number;
  ipi: number;
  pis: number;
  cofins: number;
  total: number;
}

export interface DashboardTopAccount {
  accountId: string;
  fantasia?: string | null;
  cnpj?: string | null;
  ultimoEnvioContabilidade?: Date | string | null;
  totalNotas: number;
  totalFaturado: number;
}

export interface DashboardTopProduct {
  descricao: string;
  ncm: string;
  totalNotas: number;
  totalQuantidade: number;
  totalFaturado: number;
  totalImpostos: number;
}

export interface DashboardTopRecipient {
  destinatarioDoc?: string | null;
  destinatarioNome?: string | null;
  totalNotas: number;
  totalFaturado: number;
}

export interface DashboardPaymentSummary {
  descricao: string;
  valor: number;
}

export interface DashboardChartMetrics {
  documentos: number;
  totalFaturado: number;
  ticketMedio: number;
  empresasComMovimento: number;
  nfeFaturado: number;
  nfceFaturado: number;
  nfeQuantidade: number;
  nfceQuantidade: number;
}

export interface DashboardFullResponse {
  summary: DashboardSummary;
  taxBreakdown: DashboardTaxBreakdown;
  timelineDaily: DashboardTimelineItemResponse[];
  timelineHourly: DashboardTimelineHourlyItemResponse[];
  timelineWeekly: DashboardTimelineWeekdayItemResponse[];
  topAccounts: DashboardTopAccount[];
  topProducts: DashboardTopProduct[];
  topRecipients: DashboardTopRecipient[];
  paymentsSummary: DashboardPaymentSummary[];
  chartMetrics: DashboardChartMetrics;
}

export interface NfeDocument {
  status: NfeStatus;
  modelo: NfeModelo;
  emissao: string | Date;
  total: number;
  accountId: string;
}

export interface InvoiceQuery {
  accounts?: string[];
  startDate?: Date;
  endDate?: Date;
  tipo?: NfeTipo[];
  status?: NfeStatus[];
  modelo?: NfeModelo[];
  page?: number;
  limit?: number;
}

export class InvoiceModel {
  id: string;
  ativo: boolean;
  accountId: string;
  empresaId: number;
  unidadeId: number;
  fantasia?: string;
  cnpj?: string;
  email?: string;
  contadorFantasia?: string;
  contadorCnpj?: string;
  contadorEmail?: string;
  ultimoEnvioContabilidade?: Date;

  constructor(data?: Partial<InvoiceModel>) {
    Object.assign(this, data);
  }
}
